var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-panel"},[_c('div',{staticClass:"left-section left-section-1 border-box"},[_c('leftTabsTableView')],1),_c('div',{staticClass:"left-section left-section-2 border-box"},[_c('AgeGenderChart')],1),_c('div',{staticClass:"left-section left-section-3 border-box"},[_c('DiseaseTrendChart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }